import ProfileDiscoverTab from './ProfileDiscoverTab'

export default ProfileDiscoverTab
export type { ProfileDiscoverTabProps } from './ProfileDiscoverTab'
